/**
 * Invite link-name helpers, mirroring the backend slug contract
 * (backend/models/schemas.py `_SLUG_RE`): a link name is the invite token, so
 * it must be a single URL-safe path segment of 3–64 characters.
 */

export const SLUG_MIN = 3
export const SLUG_MAX = 64

/** Same shape the backend accepts — lowercase letters, numbers, single hyphens. */
export const SLUG_RE = /^[a-z0-9]+(-[a-z0-9]+)*$/

/**
 * Derive a link name from free text (typically the invite title):
 * lowercase, every non-alphanumeric run becomes a single hyphen, and the
 * result is trimmed to the backend's 64-char ceiling. A trailing hyphen
 * exposed by the cut is dropped so the output always satisfies `SLUG_RE`.
 */
export function slugify(value: string): string {
  return value
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, SLUG_MAX)
    .replace(/-+$/g, '')
}

/** True when `value` is a link name the backend will accept. */
export function isValidSlug(value: string): boolean {
  return value.length >= SLUG_MIN && value.length <= SLUG_MAX && SLUG_RE.test(value)
}
